export type LocaleCode = 'en' | 'es' | 'de' | 'ja' | 'fr';

export const defaultLocale: LocaleCode = 'en';

export const supportedLocales: readonly LocaleCode[] = ['en', 'es', 'de', 'ja', 'fr'] as const;

export function isDefaultLocale(code: LocaleCode): boolean {
  return code === defaultLocale;
}

export function getNonDefaultLocales(): readonly LocaleCode[] {
  return supportedLocales.filter((code) => !isDefaultLocale(code));
}

export function validateLocaleConfig(
  configuredDefault: string,
  configuredSupported: readonly string[]
): void {
  if (configuredSupported.length === 0) {
    throw new Error('Locale config invariant violated: supportedLocales must be non-empty.');
  }
  if (new Set(configuredSupported).size !== configuredSupported.length) {
    throw new Error(
      'Locale config invariant violated: supportedLocales must not contain duplicates.'
    );
  }
  if (!configuredSupported.includes(configuredDefault)) {
    throw new Error(
      `Locale config invariant violated: defaultLocale "${configuredDefault}" must be a member of supportedLocales.`
    );
  }
}

validateLocaleConfig(defaultLocale, supportedLocales);

export type { LocaleAlternate } from '../storyblok/locales/HreflangTags';
